export default __webpack_public_path__ + "4edd7452550e5ee7774425608eca0f4e.wav";